$(document).ready(function (e) {
	$('body').on('hidden.bs.modal', '.modal', function () {
		$(this).removeData('bs.modal');
	});


	// try {
	// 	$('[data-fancybox="true"]').fancybox({
	// 		padding: 0,
	// 		margin: 0,
	// 		loop: true,
	// 		arrows: true,
	// 		type: 'image',
	// 		autoSize: false,
	// 		autoResize: true,
	// 		autoCenter: true,
	// 		fitToView: true,
	// 		aspectRatio: true,
	// 		openSpeed: 0,
	// 		closeSpeed: 0,
	// 		nextSpeed: 0,
	// 		prevSpeed: 0,
	// 		preload: 1,
	// 		nextClick: true,
	// 		closeBtn: true,
	// 		maxWidth: $(window).width() * 0.8,
	// 		maxHeight: $(window).height() * 0.8,
	// 		title: $(this).attr('title') 
	// 	});
	// } catch (ex) {
	// 	console.log(ex);
	// }



	$(document).on('submit', 'form[data-remote="true"]', function (e) {
		var form = $(this);

		form.find('[type="submit"]')
			.html('<i class="fa fa-spinner fa-spin"></i> Идёт отправка')
			.attr('disabled', 'disabled');

		jQuery.ajax({
			url: form.attr('action'),
			type: form.attr('method'),
			data: form.serialize(),
			dataType: 'html',
			success: function (result) {
				var content = $(form.parents('.modal-content')[0]).html(result);
				var goal = content.find('[data-goal]').data('goal');

				if (goal) {
					console.log('reachGoal', goal);
					ym(89247884, 'reachGoal', goal);
				}
			}
		});

		e.preventDefault();
	});


	$(document).on('submit', 'form[data-cart="true"]', function (e) {
		var form = $(this);

		form.find('[type="submit"]')
			.html('<span class="spinner-grow spinner-grow-sm"></span> Идёт отправка')
			.attr('disabled', 'disabled');

	});

});



// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
	'use strict';
	window.addEventListener('load', function () {
		// Fetch all the forms we want to apply custom Bootstrap validation styles to
		var forms = document.getElementsByClassName('needs-validation');
		// Loop over them and prevent submission
		var validation = Array.prototype.filter.call(forms, function (form) {
			form.addEventListener('submit', function (event) {
				if (form.checkValidity() === false) {
					event.preventDefault();
					event.stopPropagation();
				}
				form.classList.add('was-validated');
			}, false);
		});
	}, false);
})();


$('body').on('click.modal.data-api', '[data-toggle="modal"]', function () {
	$($(this).data("target") + ' .modal-content').load($(this).attr('data-remote'));
});

jQuery(function ($) {
	$('.mask-phone').mask('+7 (999) 999-99-99');
});


$(document).ready(function () {
	$('[data-toggle="popover"]').popover();
});


//var wrapper = $('#qrcode');
//if (wrapper.length > 0) {
//	wrapper.qrcode(wrapper.data('qrcode'));
//}

// You can also pass an optional settings object
// below listed default settings
AOS.init({
	// Global settings:
	disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
	startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
	initClassName: 'aos-init', // class applied after initialization
	animatedClassName: 'aos-animate', // class applied on animation
	useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
	disableMutationObserver: false, // disables automatic mutations' detections (advanced)
	debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
	throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


	// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
	offset: 100, // offset (in px) from the original trigger point
	delay: 0, // values from 0 to 3000, with step 50ms
	duration: 400, // values from 0 to 3000, with step 50ms
	easing: 'ease', // default easing for AOS animations
	once: false, // whether animation should happen only once - while scrolling down
	mirror: false, // whether elements should animate out while scrolling past them
	anchorPlacement: 'top-bottom' // defines which position of the element regarding to window should trigger the animation

});



$(window).scroll(function () {
	$('nav').toggleClass('scrolled', $(this).scrollTop() > 50);
});


jQuery(document).ready(function($){
$('#foot_phone').fadeOut();
$(window).scroll(function () {
if ($(this).scrollTop() > 800) {
	$('#foot_phone').fadeIn();
		} else {
			$('#foot_phone').fadeOut();
		}
	});
});



		$('#checkbox').click(function () {
			if ($(this).is(':checked')) {
				$('#btn').removeAttr('disabled');
				$('#btn').addClass('blik');
			} else {
				$('#btn').attr('disabled', 'disabled');
				$('#btn').removeClass('blik');
			}
		});

		// Добавление класса:
		$('input:checkbox').click(function () {
			if ($(this).is(':checked')) {
				$(this).parent().addClass('green');
			} else {
				$(this).parent().removeClass('green');
			}
		});

		// Или атрибут style:
		$('input:checkbox').click(function () {
			if ($(this).is(':checked')) {
				$(this).parent().css('color', 'green');
			} else {
				$(this).parent().css('color', '#FF0000');
			}
		});



$(function () {
    $.mask.definitions['9'] = '';
    $.mask.definitions['d'] = '[0-9]';
    $('input[type="tel"]').mask("+7(ddd) ddd-dd-dd");
});
$.fn.setCursorPosition = function(pos) {
    if ($(this).get(0).setSelectionRange) {
      $(this).get(0).setSelectionRange(pos, pos);
    } else if ($(this).get(0).createTextRange) {
      var range = $(this).get(0).createTextRange();
      range.collapse(true);
      range.moveEnd('character', pos);
      range.moveStart('character', pos);
      range.select();
    }
  };
  $('input[type="tel"]').click(function(){
    $(this).setCursorPosition(3);  // set position number
  });